module.exports = __webpack_public_path__ + "static/media/plan-image.4ec50551.svg";